
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import TexteDetail from '@/components/Texte/TexteDetail.vue';
    import Text from '@/types/Text';
    import { LoadTextePayload, TexteFilter } from '@/store/texte';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            TexteDetail,
        },
        methods: {
            ...mapActions('texte', ['loadTexte']),
            ...mapMutations('texte', ['setDialogsDetail']),
        },
        computed: {
            ...mapState('texte', ['texte', 'dialogs', 'loaders']),
        },
    })
    export default class Texte extends Vue {
        public loadTexte!: (payload?: LoadTextePayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public text = new Text();
        public search = '';

        public filter: TexteFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Text> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Code', value: 'code', width: 130 },
                { text: 'Text', value: 'text' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadTexte({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadTexte({ filter: this.filter });
        }

        public openEditText(text: Text): void {
            this.text = new Text(text);
            this.setDialogsDetail(true);
        }

        public openNeuerText(): void {
            this.text = new Text();
            this.setDialogsDetail(true);
        }
    }
